var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M176 448a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V304h-96zm64-416h-32a32 32 0 0 0-32 32v144h96V64a32 32 0 0 0-32-32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M448 240v32a32 32 0 0 1-32 32H32a32 32 0 0 1-32-32v-32a32 32 0 0 1 32-32h384a32 32 0 0 1 32 32z","className":"fa-primary","key":2})]);
}

Plus.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Plus;

Plus.default = Plus;
